import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        This project sits within the highly sought-after Duke’s Park area of
        Woodbridge, overlooking an Area of Outstanding Natural Beauty towards
        the River Deben to the south.
      </p>
      <p>
        The existing house references the Usonian style of Californian houses
        from the 1930’s, with internal level-changes, expressed materials, and
        intersecting walls creating a home that gradually reveals different
        spaces as you walk through the building.
      </p>
      <p>
        This stylised language will be developed in the new proposals, to expand
        and renovate the reception rooms creating a variety of spaces leading to
        the garden and beautiful views across the countryside.  Sleeping and
        ancillary accommodation will also be remodelled, and sensitive upgrades
        to the building envelope will modernise the whole building to current
        standards.
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/dukes-park-renovation.jsx